
//22
Object.defineProperty(exports, "__esModule", { value: true });
require("../horizontal-menu-item/HorizontalMenuItem.st.css");
module.exports.default = require("stylable/runtime").create(
    "root",
    "HorizontalMenuColumnsLayout2910420286",
    {"root":"HorizontalMenuColumnsLayout2910420286--root","menuItem":"HorizontalMenuColumnsLayout2910420286--menuItem"},
    null,
    module.id
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/components/horizontal-menu/horizontal-menu-columns-layout/HorizontalMenuColumnsLayout.st.css
// module id = 306
// module chunks = 0